<template>
  <div ref="turretTopPreview"></div>
</template>

<script>
import SVG from "svg.js"
import svgHelpers from "../../../helpers/svg_helper"

const FONT_SIZE = 0.0275 // 2.5% of the circle arc length

export default {
  props: {
    diameter: Number,
    text: String
  },
  data() {
    return {
      drawingMode: "preview"
    }
  },
  computed: {
    diameterInPx() { return svgHelpers.inchesToPx(this.diameter) },
    radius() { return this.diameterInPx / 2 },
    arcLength() { return this.diameterInPx * Math.PI },
    fontHeight() { return this.arcLength * FONT_SIZE },
    circlePath() {
      const buffer = 1,
            offset = this.fontHeight + buffer,
            adjusted_radius = this.radius - offset,
            offset_endpoint = this.diameterInPx - offset

      // SVG Help: https://www.youtube.com/watch?v=k6TWzfLGAKo
      return `
        M ${offset} ${this.radius}
        A ${adjusted_radius},${adjusted_radius} 0 0,1 ${offset_endpoint},${this.radius}
        A ${adjusted_radius},${adjusted_radius} 0 0,1 ${offset},${this.radius}
      `
      },
    downloadFileName() { return `TOP - ${this.text}` }
  },
  methods: {
    draw(drawingMode = "preview") {
      this.drawingMode = drawingMode
      svgHelpers.setViewboxByMode(this.svg, this.drawingMode, this.diameterInPx, this.diameterInPx)
      svgHelpers.resizeSVGBySizeMode(this.svg, this.drawingMode, this.diameterInPx, this.diameterInPx)

      this.drawBackground(drawingMode)
      this.drawPathAndText()
    },
    redraw(mode = "preview") {
      this.svg.clear()
      this.draw(mode)
    },
    drawBackground(drawingMode) {
      if (this.drawingMode === "png") {
        return
      }

      const sizeMode = drawingMode === "download" ? "sized" : "responsize"
      svgHelpers.drawBackground(this.svg, this.drawingMode, sizeMode, this.diameterInPx, this.diameterInPx)
    },
    drawPathAndText() {
      const text = this.svg.text((add) => add.tspan(this.text))

      text
        .font({size: this.fontHeight})
        .fill(svgHelpers.itemsFillColor(this.drawingMode))
        .attr({"dominant-baseline": "text-after-edge"})
        .path(this.circlePath)
    },
    download() {
      this.redraw("png")
      svgHelpers.downloadSvgAsPng(this.svg, this.diameterInPx, this.diameterInPx, this.downloadFileName)
      this.redraw()
    }
  },
  mounted() {
    this.svg = SVG(this.$refs.turretTopPreview)
    this.svg.viewbox(0, 0, this.diameterInPx, this.diameterInPx)
    this.draw()
  }
}
</script>
